import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    settings: {},
    loading: false,
  }),
  mutations: {
    setSettings(state, payload) {
      state.settings = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchSettings(context) {
      return withLoading(async () => {
        const response = await api.get("/user_integration_settings")
        context.commit("setSettings", response.data)
      }, context)
    },

    async createSetting(context, params) {
      return withLoading(async () => {
        const response = await api.post("/user_integration_settings", params)
        context.commit("setSettings", response.data)
      }, context)
    },

    async updateSetting(context, { id, ...params }) {
      return withLoading(async () => {
        const response = await api.put(`/user_integration_settings/${id}`, params)
        context.commit("setSettings", response.data)
      }, context)
    },

    async deleteSetting(context, id) {
      return withLoading(async () => {
        const response = await api.delete(`/user_integration_settings/${id}`)
        context.commit("setSettings", response.data)
      }, context)
    }
  }
}